// import { client } from 'venuescanner-js/services/socketClient'
// export default ({ inboxService, states }) => {
//   /**
//    * @typedef {Object} accessibleCollection - Object containing venues, networks and me
//   * @property {Object[]} venues - Array of Venues according to the inbox schema
//   * @property {Object[]} networks - Array of Networks according to the inbox schema
//   * @property {Object[]} users - Array of Users, to include on the accessing user
//    */

//   return {

//     /** @function
//      * @async
//      * @name fetch
//      * @desc Fetches venues, networks and me
//      * @returns {accessibleCollection}
//      */
//     fetch: async function () {
//       return client.sendPromise('room', {
//         getVenues: {}
//       })
//     }
//   }
// }

import { client } from "venuescanner-js/services/socketClient";
import consume from "./models/consume";
const venues = ({ inboxService, states }) => {
  /**
   * @typedef {Object} accessibleCollection - Object containing venues, networks and me
   * @property {Object[]} venues - Array of Venues according to the inbox schema
   * @property {Object[]} networks - Array of Networks according to the inbox schema
   * @property {Object[]} users - Array of Users, to include on the accessing user
   */
  return {
    /** @function
     * @async
     * @name venues.fetch
     * @desc Fetches venues, networks and me
     * @memberof! module:inboxService
     * @returns {accessibleCollection}
     */
    fetch: async function () {
      const { venues, users, networks } = await client.sendPromise("room", {
        getVenues: {},
      });
      return {
        venues: consume("venue", venues),
        users: consume("user", users),
        networks: consume("network", networks),
      };
      // Object.keys(data).forEach(modelName => {
      //   data[modelName] = consume(modelName, data[modelName])
      // })
      // const { venue, user,  } = data
      // return { threads: thread_preview, counts }
    },
    /** @function
     * @async
     * @name venues.fetchSpaces
     * @desc Fetches spaces by venue id
     * @memberof! module:inboxService
     * @returns {accessibleCollection}
     */
    fetchSpaces: async function (venueId) {
      const { spaces } = await client.sendPromise("room", {
        getSpaces: { venueId },
      });
      return {
        spaces: consume("space", spaces),
      };
      // Object.keys(data).forEach(modelName => {
      //   data[modelName] = consume(modelName, data[modelName])
      // })
      // const { venue, user,  } = data
      // return { threads: thread_preview, counts }
    },
  };
};

export default venues;
